import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Select from "react-select";
import { useGetAllCarsQuery } from "@/redux/carApi";
import { useGetMyRentCorpQuery } from "@/redux/rentCorpApi";

export const VehicleListPopup = ({
    layer = true,
    onClose,
    setFormData,
    rentCorpId, // 현재 선택된 계약서의 rentCorpId
    onRentCorpSelect, // 계약서의 rentCorpId를 업데이트하는 콜백
    onVehicleSelect, // 선택한 차량 데이터를 부모로 전달하는 콜백
}) => {
    const [query, setQuery] = useState("");
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    // 사업자 리스트 조회
    const { data: myRentCorpData } = useGetMyRentCorpQuery();
    const corpOptions =
        myRentCorpData && myRentCorpData.data
            ? myRentCorpData.data.map((item) => ({
                  value: item.id,
                  label: item.corpName,
              }))
            : [];

    const { data: carsData, refetch } = useGetAllCarsQuery({ rent_corp_id: rentCorpId, query }, { skip: !rentCorpId });

    const handleSearch = () => {
        if (!rentCorpId) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "사업자를 먼저 선택하세요.",
            }));
            return;
        }
        refetch();
    };

    const handleSelectVehicle = (vehicle) => {
        setSelectedVehicle(vehicle);
    };

    const handleConfirm = () => {
        if (!selectedVehicle) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "차량을 선택하세요.",
            }));
            return;
        }
        onVehicleSelect(selectedVehicle);
        onClose();
    };

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>
            <div className="popup vehicle-list-popup">
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">차량 선택</span>
                    </div>
                    <div className="btn-close" onClick={onClose}></div>
                </div>
                <div className="popup-content">
                    <div className="table-container">
                        <div className="table-filter">
                            <div className="filter-row">
                                <div className="filter-item">
                                    <div className="item-content">
                                        {/* 사업자 선택: 선택 시 onRentCorpSelect 호출 */}
                                        <div className="item-input">
                                            <Select
                                                options={corpOptions}
                                                className="custom-select"
                                                classNamePrefix="custom-select"
                                                isSearchable={false}
                                                placeholder="사업자 선택"
                                                value={corpOptions.find((opt) => opt.value === rentCorpId)}
                                                onChange={(option) => onRentCorpSelect(option.value)}
                                            />
                                        </div>
                                        <div className="item-input">
                                            <input
                                                type="text"
                                                placeholder="차량번호 입력"
                                                value={query || ""}
                                                onChange={(e) => setQuery(e.target.value)}
                                            />
                                        </div>
                                        <div className="item-buttons">
                                            <button type="button" className="btn-search" onClick={handleSearch}>
                                                검색
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 차량 리스트 */}
                        <div className="table-content">
                            <div className="table-wrapper">
                                <div className="table">
                                    <table>
                                        <colgroup>
                                            <col width={"12%"} />
                                            <col width={"17%"} />
                                            <col width={"34%"} />
                                            <col width={"17%"} />
                                            <col width={"20%"} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">선택</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">차량번호</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">차량모델</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">담당자</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">연락처</div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {carsData && carsData.data && carsData.data.length > 0 ? (
                                                carsData.data.map((vehicle) => (
                                                    <tr key={vehicle.id}>
                                                        <td>
                                                            <div className="cell" style={{ height: "100%" }}>
                                                                <div className="input-checkbox">
                                                                    <div className="checkbox" style={{ display: "flex" }}>
                                                                        <input
                                                                            type="radio"
                                                                            name="selectedVehicle"
                                                                            id={`selectedVehicle-${vehicle.id}`}
                                                                            checked={selectedVehicle?.id === vehicle.id}
                                                                            onChange={() => handleSelectVehicle(vehicle)}
                                                                        />
                                                                        <label htmlFor={`selectedVehicle-${vehicle.id}`}></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{vehicle.carNumber}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{vehicle.modelName}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{vehicle.color}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{vehicle.phone}</div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="data-empty">
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">차량 데이터가 없습니다.</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button type="button" className="btn btn-primary btn-cancel" onClick={onClose}>
                        취소
                    </button>
                    <button type="button" className="btn btn-primary btn-confirm" onClick={handleConfirm}>
                        완료
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};
